"use client";

import { FC } from "react";
import { useTranslations } from "next-intl";

import { IconType, IOfficeLocation } from "@types";

import { Icon } from "components/atoms/Icon/Icon";

import { OfficeLocationRecord } from "@graphql/types/graphql";
import s from "./OfficeLocation.module.scss";

interface Props {
  location: OfficeLocationRecord;
}

export const OfficeLocation: FC<Props> = ({ location }) => {
  const t = useTranslations("common");
  const loc = location as IOfficeLocation;
  const address = `${loc.officeAddress?.street} ${loc.officeAddress?.housenumber}, ${loc.officeAddress?.postcode} ${loc.officeAddress?.city}, ${loc.officeAddress?.country}`;

  return (
    <div className={s.OfficeLocation}>
      {loc.officeAddress && (
        <div>
          <p className={s.Pretitle}>{t("address")}</p>
          <p>{address}</p>
          <p>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                address,
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={s.Icon}>
                {t("open-google-maps")}
                <Icon name={IconType.UrlLink} size="l" color="black" />
              </span>
            </a>
          </p>
        </div>
      )}
      {(loc.email || loc.phone) && (
        <div>
          <p className={s.Pretitle}>{t("contact")}</p>
          <ul>
            {loc.email && (
              <li>
                <a href={`mailto: ${loc.email}`}>
                  <span className={s.Icon}>
                    <Icon name={IconType.Email} size="l" color="black" />
                    {loc.email}
                  </span>
                </a>
              </li>
            )}
            {loc.phone && (
              <li>
                <a href={`tel: ${loc.phone}`}>
                  <span className={s.Icon}>
                    <Icon name={IconType.Phone} size="l" color="black" />
                    {loc.phone}
                  </span>
                </a>
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};
